import { render, staticRenderFns } from "./yysd-teeth.vue?vue&type=template&id=13585da3&scoped=true"
import script from "./yysd-teeth.vue?vue&type=script&lang=js"
export * from "./yysd-teeth.vue?vue&type=script&lang=js"
import style0 from "./yysd-teeth.vue?vue&type=style&index=0&id=13585da3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13585da3",
  null
  
)

export default component.exports